var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHamburgerClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    enableBackground: "new 0 0 150 150",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2825",
    transform: "translate(2537.561 102.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_10503"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeMiterlimit: 10,
    d: "M-2409.76,30.527c-1.351,0-2.7-0.45-3.75-1.5l-105.601-105.601 c-2.1-2.1-2.1-5.4,0-7.5c2.101-2.1,5.4-2.1,7.5,0l105.601,105.601c2.1,2.101,2.1,5.399,0,7.5 C-2406.911,29.926-2408.411,30.527-2409.76,30.527z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_10504"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeMiterlimit: 10,
    d: "M-2515.361,30.527c-1.35,0-2.7-0.45-3.75-1.5c-2.1-2.101-2.1-5.399,0-7.5 l105.6-105.601c2.1-2.1,5.4-2.1,7.5,0s2.1,5.4,0,7.5l-105.6,105.601C-2512.511,29.926-2513.861,30.527-2515.361,30.527z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerClose);
export default __webpack_public_path__ + "static/media/hamburger-close.b77bf7499e4486131345330848470cf1.svg";
export { ForwardRef as ReactComponent };